module.exports = __webpack_public_path__ + "img/us_img.29858412.png";